import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import PTProspects from "../../components/pt/pt-prospect-management/PTProspects";

const PTProspectManagement = () => {
  const userInfoData = useSelector(selectUser);

  return <PTProspects userInfoData={userInfoData} />;
};

export default PTProspectManagement;
